export default {
      id: "ic_forgot_password-usage",
      viewBox: "0 0 56 56",
      url: "/" + "images/icons.3.109.2.svg#ic_forgot_password-usage",
      toString: function () {
        return this.url;
      }
    }